const backgroundVideoToggles = document.querySelectorAll(
	".background-video__toggle",
);

backgroundVideoToggles.forEach((toggle) => {
	const wrapper = toggle.closest(".background-video") || document;
	const videos = Array.from(wrapper.querySelectorAll("video"));
	const mute = wrapper.querySelector(".background-video__mute");
	const videoLabel = toggle.dataset.videoLabel || "video";
	let frame;

	if (!videos.length) {
		return;
	}

	const getActiveVideo = () =>
		videos.find((video) => video.offsetParent !== null) || videos[0];

	const sync = () => {
		const video = getActiveVideo();
		const isPaused = video.paused;

		toggle.classList.toggle("is-paused", isPaused);
		toggle.setAttribute("aria-pressed", isPaused ? "true" : "false");
		toggle.setAttribute(
			"aria-label",
			isPaused ? "Play " + videoLabel : "Pause " + videoLabel,
		);
		toggle.style.setProperty(
			"--toggle-progress",
			video.currentTime / video.duration,
		);
	};

	const syncMute = () => {
		if (!mute) {
			return;
		}

		const video = getActiveVideo();
		const isMuted = video.muted;

		mute.classList.toggle("is-muted", isMuted);
		mute.setAttribute("aria-pressed", isMuted ? "true" : "false");
		mute.setAttribute(
			"aria-label",
			isMuted ? "Unmute " + videoLabel : "Mute " + videoLabel,
		);
	};

	const update = () => {
		const video = getActiveVideo();
		sync();

		if (!video.paused && !video.ended) {
			frame = requestAnimationFrame(update);
		}
	};

	videos.forEach((video) => {
		video.addEventListener("loadedmetadata", sync);
		video.addEventListener("pause", sync);
		video.addEventListener("volumechange", syncMute);

		video.addEventListener("play", () => {
			if (video === getActiveVideo()) {
				cancelAnimationFrame(frame);
				update();
			}
		});

		video.addEventListener("ended", () => {
			if (video === getActiveVideo()) {
				cancelAnimationFrame(frame);
				toggle.style.setProperty("--toggle-progress", 0);
				sync();
			}
		});
	});

	sync();
	syncMute();

	toggle.addEventListener("click", (event) => {
		event.preventDefault();

		const video = getActiveVideo();

		if (toggle.classList.contains("is-paused")) {
			const playPromise = video.play();
			if (playPromise && typeof playPromise.catch === "function") {
				playPromise.catch(() => {});
			}
			return;
		}

		video.pause();
	});

	if (mute) {
		mute.addEventListener("click", (event) => {
			event.preventDefault();

			const shouldMute = !getActiveVideo().muted;
			videos.forEach((video) => {
				video.muted = shouldMute;
			});
			syncMute();
		});
	}
});
